module.exports = __webpack_public_path__ + "img/raidd_benbeckner52.4d809eb.png";